export default "__VITE_ASSET__DUwxVM39__"